import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  ssDialogService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './examined-by-dialog.controller';
import template from './examined-by-dialog.html';
import assessmentHealthResourceMessagesTpl from '../messages/assessment.HealthResource.messages.html';
import assessmentAnalysisDateMessagesTpl from '../messages/assessment.analysis-date.messages.html';


class dialogService {
  getOptions($event, { LOCALS_VARS }) {
    return {
      controller,
      controllerAs: 'examinedByDialogVM',
      locals: {
        LOCALS_VARS
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event, // <-- Only keep if required
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.examinedByDialog', [
  alerts,
  bcpDataService,
  constants,
  ssDialogService,
])
  .service('examinedByDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('assessment.HealthResource.messages.html', assessmentHealthResourceMessagesTpl);
    $templateCache.put('assessment.analysis-date.messages.html', assessmentAnalysisDateMessagesTpl);
  })
  .name;
